const MEDIA_BASE = 'https://thegita.org.in';

export const AUDIO_VOICES = ['male', 'female'];

export const chapterImageUrl = (chapterNumber) =>
  `${MEDIA_BASE}/images/chapters/${chapterNumber}.jpeg`;

export const slokaImageUrl = (chapterNumber, slokaNumber) =>
  `${MEDIA_BASE}/images/slokas/Chapter${chapterNumber}/${slokaNumber}.jpeg`;

function imageNameVariants(label) {
  const trimmed = String(label).trim();
  if (!trimmed) return [];
  return [...new Set([
    trimmed,
    trimmed.replace(/\s+/g, ''),
    trimmed.replace(/\s+/g, '_'),
  ])];
}

export const speakerImageUrl = (speakerName) => {
  const variants = imageNameVariants(speakerName);
  const name = variants[0]?.replace(/\s+/g, '');
  return name ? `${MEDIA_BASE}/images/Characters/${encodeURIComponent(name)}.jpg` : null;
};

export function speakerImageUrls(speakerName) {
  return imageNameVariants(speakerName).map(
    (name) => `${MEDIA_BASE}/images/Characters/${encodeURIComponent(name)}.jpg`
  );
}

/** Mahabharata family portraits — images/family/{Name}.jpeg (spaces allowed in filenames). */
export const familyImageUrl = (personName) => {
  const variants = imageNameVariants(personName);
  return variants.length
    ? `${MEDIA_BASE}/images/family/${encodeURIComponent(variants[0])}.jpeg`
    : null;
};

export function familyImageUrls(personName) {
  return imageNameVariants(personName).map(
    (name) => `${MEDIA_BASE}/images/family/${encodeURIComponent(name)}.jpeg`
  );
}

/** Family page: try exact name, then no-space/underscore variants; Speakers folder as fallback. */
export function characterImageUrls(name, sourceName) {
  const labels = [name, sourceName].filter(Boolean);
  const urls = [];
  for (const label of labels) {
    for (const url of [...familyImageUrls(label), ...speakerImageUrls(label)]) {
      if (!urls.includes(url)) urls.push(url);
    }
  }
  return urls;
}

/** Prefer sloka art when available; callers should handle fallback via SlokaArtImage. */
export const verseArtUrl = (chapterNumber, slokaNumber) =>
  slokaNumber != null
    ? slokaImageUrl(chapterNumber, slokaNumber)
    : chapterImageUrl(chapterNumber);

export const slokaAudioUrl = (chapterNumber, slokaNumber, voice = 'male') =>
  `${MEDIA_BASE}/audio/slokas/${voice}/Chapter${chapterNumber}/${chapterNumber}_${slokaNumber}.mp3`;

export const meaningAudioUrl = (language, chapterNumber, slokaNumber) =>
  `${MEDIA_BASE}/audio/meanings/${language}/${chapterNumber}/Chapter${chapterNumber}_Sloka_${slokaNumber}.mp3`;

export const slokaVideoUrl = (chapterNumber, slokaNumber) =>
  `${MEDIA_BASE}/videos/slokas/Chapter${chapterNumber}/${slokaNumber}.mp4`;
